import { Capacitor } from '@capacitor/core'

export const isNativePlatform = (): boolean => Capacitor.isNativePlatform()

export const getNativePlatform = (): 'ios' | 'android' | 'web' => {
  const platform = Capacitor.getPlatform()
  if (platform === 'ios' || platform === 'android') return platform
  return 'web'
}

export const SIGNUP_URL = 'https://www.shiptanbul.com/start-here'

export const getWebAppBaseUrl = (): string => {
  const fromEnv = import.meta.env.VITE_WEB_APP_URL
  if (fromEnv) return fromEnv.replace(/\/$/, '')
  if (import.meta.env.MODE === 'staging') return 'https://test.shiptanbul.com'
  return 'https://app.shiptanbul.com'
}
